module.exports = {
      id: "olympic-usage",
      viewBox: "0 0 11.388 19.966",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#olympic",
      toString: function () {
        return this.url;
      }
    }